<template>
    <vSelect v-model="value"
        :options="options"
        @search="onSearch"
        label="denominazione"
        :searchable="true">
        <template #option="option">
            <span class="">
                <template v-if="option.istituto">
                    {{ option.istituto }} -
                </template>
                {{ option.denominazione }}<br/>
                <small>
                    <template v-if="option.tipo">
                        <span class="badge bg-light text-dark">{{ option.tipo }}</span>
                    </template>
                    {{ option.indirizzo }} {{ option.comune }}
                </small>
            </span>
        </template>
        <template #selected-option="option">
            <span class="">
                <template v-if="option.istituto">
                    {{ option.istituto }} -
                </template>
                {{ option.denominazione }}<br/>
                <small>
                    <template v-if="option.tipo">
                        <span class="badge bg-light text-dark">{{ option.tipo }}</span>
                    </template>
                    {{ option.indirizzo }} {{ option.comune }}
                </small> 
            </span>
        </template>
        <template #no-options="{ search, searching, loading }">
            <template v-if="!search">
                Ricerca digitando le prime lettere.
            </template>
            <template v-else>
                Nessun risultato trovato, prova con una nuova ricerca.
            </template>
        </template>
    </vSelect>
</template>
<script>

import vSelect from 'vue-select'
import axiosService from "@/service/AxiosService";

export default {
    components: {
        vSelect
    },
    props: {
        modelValue: [Array, Object, String],
        provinciaDictionaryId: {
            type: String,
        },
    },
    data() {
        return {
            options: []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        onSearch(search, loading) {
            if (!search) {
                this.options = []
                return
            }

            loading(true)

            axiosService.axios.get('/api/v1/bado/scuola/' + this.provinciaDictionaryId + '?q=' + search)
                .then((response) => {
                    this.options = response.data
                    loading(false)
                })
        }
    }
}
</script>